import Lottie from 'lottie-react'
import { DARK_TREATMENTS, type DarkTreatment } from './darkTreatment'
import aiAnimation from '../../assets/animations/ai-icon.json'

interface AIIconProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string
  /**
   * How the icon handles a dark surface. Defaults to 'none', which is what this
   * component did before the prop existed: no filter at all. It gets away with that
   * because the artwork is mostly blue, which reads on either surface, unlike the
   * mostly-black icons that need a treatment.
   */
  darkTreatment?: DarkTreatment
}

const AIIcon = ({ className = 'h-8 w-8', darkTreatment = 'none', ...props }: AIIconProps) => {
  return (
    <div className={className} style={{ aspectRatio: '1 / 1', contain: 'layout' }} {...props}>
      <div className={`${DARK_TREATMENTS[darkTreatment]} w-full h-full`}>
        <Lottie
          animationData={aiAnimation}
          loop={true}
          autoplay={true}
          className="w-full h-full"
        />
      </div>
    </div>
  )
}

export default AIIcon